// extracted by mini-css-extract-plugin
module.exports = {"section":"PageHome_section__GqqL8"};